export default {
  'en-US': require(`./en-US.json`),
  'en-CA': require(`./en-US.json`),
  'fr-CA': require(`./fr-CA.json`),
};
